/* globals siteurl */
import { updateCosts } from './cart';


const submitCode = function () {
  $('#discount-code-error-message').addClass('is-hidden');
  $('.js-discount-amount').addClass('is-hidden');
  const code = $('#code').val();
  const action = $.post(
    //`${siteurl}ajax/discount_code`,
    `${siteurl}ajax/cart/discount-code/submit`,
    { code },
    (data) => {

    },
    'json',
  );

  action.done((data) => {
    if (data.discount_error_status === 'error') {
      $('#discount-code-error-message').html(data.discount_error_message).removeClass('is-hidden');
    } else {
      /*
      const discountValue = parseInt(data.discount_value.charAt(0));
      if (discountValue > 0) {
        $('.js-discount-value').html(`-${data.discount_value}`);
        $('.js-discount-amount').removeClass('is-hidden');
      }
      $('#discount-code-text').html(data.discount_code);
      $('#to-use-discount-code-box').addClass('is-hidden');
      $('#used-discount-code-box').removeClass('is-hidden');
      updateCosts(data);
      */
      window.location.reload();
    }

  });
};
const unsetCode = function () {
  const action = $.post(
    //`${siteurl}ajax/unset_discount`,
    `${siteurl}ajax/cart/discount-code/delete`,
    (data) => {
      $('#total-no-discount').html('');
      $('.final-price-no-discount').html('');
      $('.js-discount-amount').addClass('is-hidden');
      $('#to-use-discount-code-box').removeClass('is-hidden');
      $('#used-discount-code-box').addClass('is-hidden');
      updateCosts(data);
    },
    'json',
  );

  action.done(() => {
    window.location.reload();
  });
};
$('.js-submit-code').click(submitCode);

$('.js-unset-code').click(unsetCode);

$('#code').focus(function () {
  $(this).bind('keypress', (e) => {
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code == 13) {
      submitCode();
    }
  });
});
